// extracted by mini-css-extract-plugin
export default {"container":"Form_container__ihQVK","containerForm":"Form_containerForm__kMNj2"};